// extracted by mini-css-extract-plugin
export default {"headerContainer":"Settings_headerContainer__GG-Ib","secondaryHeader":"Settings_secondaryHeader__JFOf9","buttonsContainer":"Settings_buttonsContainer__VjxYQ"};